<template>
  <div class="mortgage-guidance-selection">
    <dashboard-page :image-header-props="imageHeaderProps">
      <template v-slot:header>
        <div class="headline-container">
          <div class="ri-body">יעוץ משכנתא</div>
          <div class="title-text margin-top-m">
            איזה ליווי משכנתא<br>הכי מתאים לך?
          </div>
        </div>
      </template>
      <template v-slot:dashboard>
        <mortgage-guidance-type-button
          @guidance-type-selected="selectType"
          :selected="selectedType === GUIDANCE_TYPES.FULL"
          :guidance-type="GUIDANCE_TYPES.FULL"
          main-text="ליווי מלא"
          price="6,800"
          description="הכל עלינו - מא׳ ועד ת׳. בניית התמהיל המשתלם ביותר, משא ומתן וקשר שוטף עם הבנקים - והחתימה הסופית."
        />
      </template>
      <mortgage-guidance-type-button
        class="margin-ml margin-top-m"
        @guidance-type-selected="selectType"
        :selected="selectedType === GUIDANCE_TYPES.FOCUSED"
        :guidance-type="GUIDANCE_TYPES.FOCUSED"
        main-text="ליווי ממוקד"
        price="2,900"
        description="התמהיל המשתלם ביותר - עלינו. המשא ומתן עם הבנקים - עליך. אנחנו כאן לעזרה בכל שאלה."
      />
      <div class="cta-container margin-ml margin-top-xl">
        <riseup-button
          title="להמשך"
          color="blue"
          size="slim"
          :disabled="!selectedType"
          @click="onContinueClick"
        />
      </div>
    </dashboard-page>
  </div>
</template>

<script>
import BaseUi from '@riseupil/base-ui';
import { BACKGROUND_POSITION } from '@riseupil/base-ui/src/utils/layout-consts';
import Segment from '@/Segment';
import { mapActions, mapState } from 'vuex';
import MortgageGuidanceTypeButton from './MortgageGuidanceTypeButton.vue';

const GUIDANCE_TYPES = {
  FOCUSED: 'mortgage-partial-2900',
  FULL: 'mortgage-6800',
};

export default {
  name: 'MortgageGuidanceSelectionPage',
  components: {
    MortgageGuidanceTypeButton,
    DashboardPage: BaseUi.Pages.DashboardPage,
    RiseupButton: BaseUi.RiseupButton,
  },
  data() {
    return {
      selectedType: null,
      GUIDANCE_TYPES,
    };
  },
  created() {
    Segment.trackUserInteraction('MortgageGuidanceSelectionPage_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: BaseUi.LayoutConsts.COLOR_VARIANT.BLUE,
      textColor: BaseUi.Colors.riseupWhite,
      logoColor: BaseUi.Colors.riseupWhite,
    });
  },
  computed: {
    ...mapState('session', ['customerId']),
    imageHeaderProps() {
      return {
        // eslint-disable-next-line global-require
        imgSrc: require('@/assets/subscription/subscription-type-header.svg'),
        backgroundColor: BaseUi.LayoutConsts.COLOR_VARIANT.BLUE,
        bottomSeparator: false,
        textColor: BaseUi.LayoutConsts.COLOR_VARIANT.WHITE,
        backgroundPosition: BACKGROUND_POSITION.BOTTOM,
      };
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
    selectType({ guidanceType }) {
      this.selectedType = guidanceType;
      Segment.trackUserInteraction('MortgageGuidanceSelectionPage_TypeSelected', { guidanceType });
    },
    onContinueClick() {
      Segment.trackUserInteraction('MortgageGuidanceSelectionPage_ContinueClicked', {
        selectedType: this.selectedType,
      });
      this.$router.push({
        name: 'one-off',
        params: { offeringId: this.selectedType },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.mortgage-guidance-selection {
  display: flex;
  flex-direction: column;

  .headline-container {
    text-align: start;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex: 1;
    color: $riseup_white;

    .title-text {
      font-size: 28px;
      font-weight: bold;
      line-height: 1.3;
    }
  }

  .cta-container {
    margin-bottom: 24px;
  }

  ::v-deep .header-card {
    overflow: visible;
    outline: unset;

    .card-body {
      overflow: visible;
    }
  }
}
</style>
